export default __webpack_public_path__ + "static/hero-img-f0eea059b2ed2f18bee536c9f6d5376d.png";